import React, { useEffect, useState, useContext } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { LanguageContext } from "App";
import { useLocation } from "react-router-dom";
import AppointmentsApi from "../../../Classes/API/Appointments/AppointmentsApi";
import SearchStringOrIntReq from "../../../Classes/Models/Requests/SearchStringOrIntReq";
import Swal from "sweetalert2";
import { Card, CardHeader } from "@mui/material";
import HourAppointmentsTable from "./HourAppointmentsTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Loader from "layouts/loader/loader";
import "./style.scss";
import MDButton from "components/MDButton";

const index = () => {
  const { translations, switchLanguage } = useContext(LanguageContext);
  const { state } = useLocation();
  const [IsLoading, setIsLoading] = useState(false);
  const [AppDay, setAppDay] = useState([]);
  const [Hour, setHour] = useState(9);
  const [dateDay, setdateDay] = useState();

  useEffect(async () => {
    await GetAppHoursByhour(state.AppDay.id, Hour);
  }, []);

  useEffect(() => {}, [AppDay]);

  const GetAppDayById = async (Id) => {
    let req = new SearchStringOrIntReq();
    req.SearchInt = Id;

    let res = await AppointmentsApi.GetAppointmentDayByIdSimplified(req);

    if (res.status == "Success") {
      setAppDay(res.data);
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const GetAppHoursByhour = async (Id, hour) => {
    if (Hour != hour) {
      setHour(hour);
    }
    if (!IsLoading) {
      setIsLoading(true);
    }
    let req = new SearchStringOrIntReq();
    req.SearchInt = Id;
    req.HoursIndex = hour;

    let res = await AppointmentsApi.GetAppointmentDayHoursByHours(req);

    if (res.status == "Success") {
      setAppDay(res.data);
      setIsLoading(false);
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const OnchangeHour = async (hour) => {
    setHour(hour);
    await GetAppHoursByhour(state.AppDay.id, Hour);
  };

  const ExportExcel = async () => {
    Swal.fire({
      title: "Exporting",
      icon: "info",
      text: "Please wait",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    let req = new SearchStringOrIntReq();
    req.SearchInt = state.AppDay.id;

    let res = await AppointmentsApi.ExportAppointmentDay(req);
    var csvURL = window.URL.createObjectURL(res);
    let tempLink = document.createElement("a");
    tempLink.href = csvURL;
    tempLink.setAttribute("download", "AppointmentDay.xlsx");
    tempLink.click();
    Swal.fire({
      title: "Exported",
      icon: "success",
      text: "Exported successfully",
    });
  };

  const ExportExcelList = async () => {
    Swal.fire({
      title: "Exporting",
      icon: "info",
      text: "Please wait",
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let req = new SearchStringOrIntReq();
    // req.SearchInt = AppDay[0].appointmentDayId;
    req.SearchInt = state.AppDay.id;
    let res = await AppointmentsApi.ExportAccountingDay(req);
    var csvURL = window.URL.createObjectURL(res);
    let tempLink = document.createElement("a");
    tempLink.href = csvURL;
    tempLink.setAttribute(
      "download",
      "AppointmentDay " + new Date(state.AppDay.dateDay).toLocaleDateString() + ".xlsx"
    );
    tempLink.click();
    Swal.fire({
      title: "Exported",
      icon: "success",
      text: "Exported successfully",
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <CardHeader title={translations.HourDetails} />
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ padding: "1em" }}
        >
          <div className="hour-option">
            <MDTypography variant="h5" mb={5} className="selected-hour">
              {translations.appointmentPatientsEnteriesSelectedDate}
              {new Date(state.AppDay.dateDay).toLocaleDateString("en-GB").split(",")[0]}
            </MDTypography>
            <MDTypography variant="h5" mb={5} className="selected-hour">
              {translations.appointmentPatientsEnteriesSelectedHour}: {Hour}
            </MDTypography>

            <select
              value={Hour}
              onChange={(e) => GetAppHoursByhour(state.AppDay.id, e.target.value)}
            >
              <option value={0}>00:00</option>
              <option value={1}>01:00</option>
              <option value={2}>02:00</option>
              <option value={3}>03:00</option>
              <option value={4}>04:00</option>
              <option value={5}>05:00</option>
              <option value={6}>06:00</option>
              <option value={7}>07:00</option>
              <option value={8}>08:00</option>
              <option selected={true} value={9}>
                09:00
              </option>
              <option value={10}>10:00</option>
              <option value={11}>11:00</option>
              <option value={12}>12:00</option>
              <option value={13}>13:00</option>
              <option value={14}>14:00</option>
              <option value={15}>15:00</option>
              <option value={16}>16:00</option>
              <option value={17}>17:00</option>
              <option value={18}>18:00</option>
              <option value={19}>19:00</option>
              <option value={20}>20:00</option>
              <option value={21}>21:00</option>
              <option value={22}>22:00</option>
              <option value={23}>23:00</option>
            </select>
          </div>
          <div>
            <MDButton
              sx={{
                backgroundColor: "3560AD",
                "&:hover": { backgroundColor: "#4682B4" },
                marginRight: "7px",
              }}
              color="text"
              onClick={ExportExcel}
            >
              {translations.appointmentPatientsEnteriesSchedule}
            </MDButton>

            <MDButton
              sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
              color="text"
              onClick={ExportExcelList}
            >
              {translations.appointmentPatientsEnteriesDailyPatientRepor}
            </MDButton>
          </div>
        </MDBox>
        {IsLoading ? (
          <DashboardLayout>
            {" "}
            <Loader />{" "}
          </DashboardLayout>
        ) : (
          <HourAppointmentsTable SelectedApps={AppDay} />
        )}
      </Card>
    </DashboardLayout>
  );
};

export default index;
